import { useWidgetContext } from '../context/WidgetContext';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { getForgotPasswordLink, getPasswordResetUrlByClientId, isAthenaOneWebClient } from '../../utils/app-utils';
import { Button } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';
import { launchLwa } from '../../utils/lwa-utils';
import athenaConfig from '../../config';

const FORGOT_PASSWORD_HASH = '#signin/athena-forgot-password';

export default function ForgotPasswordLink() {
  const {
    settings: { clientId, isAuthnWithLwaClientId },
    athenaOneWebSso,
  } = useWidgetContext();
  if (athenaOneWebSso) return <></>;
  const forgotPasswordUrl = getForgotPasswordLink(clientId);
  const shouldLinkBeDisplayed = isAthenaOneWebClient() || isAuthnWithLwaClientId;

  // Check if native password reset is enabled via feature flag
  const useNativeFlow = athenaConfig.featureFlags.enableNativePasswordReset;

  if (shouldLinkBeDisplayed) {
    return (
      <Button
        text={getLocalizedString('forgotpassword')}
        className="fe_u_font-size--small"
        variant={'tertiary'}
        onClick={async () => {
          await AmplitudeUtils.logCustomEvent('ForgotPasswordButtonClick', {});

          if (isAthenaOneWebClient() && useNativeFlow) {
            // Find and trigger click on Okta's native forgot password link
            const $forgotPasswordLink = jQueryCourage('a[data-se="forgot-password"]');

            if ($forgotPasswordLink.length > 0) {
              $forgotPasswordLink.trigger('click');
            }
            else {
              // Fallback: redirect to URL based on client mapping
              const passwordResetUrl = getPasswordResetUrlByClientId(clientId);
              if (passwordResetUrl) {
                window.location.assign(passwordResetUrl);
              }
            }
          }
          else if (isAthenaOneWebClient()) {
            // Use existing custom flow for athenaOne web clients when flag is disabled
            window.location.assign(forgotPasswordUrl!);
          }
          else {
            // Use existing LWA flow for non-athenaOne clients
            await launchLwa({ hash: FORGOT_PASSWORD_HASH });
          }
        }}
      />
    );
  }

  return <></>;
}
